import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { allMappingsAction } from '../../redux/actions/upcScanActions';
import Loader from '../loader/loader';
import MappingButtons from './MappingButtons';
import Pagination from '../shared/Pagination';
import normalizeUpc from '../../utils/normalizeUpc';

const toSearchBarcode = (raw) => {
    const trimmed = String(raw || "").trim();
    if (!trimmed) return "";
    return normalizeUpc(trimmed) || trimmed;
};

const MappingList = ({ validateBarcode }) => {

    const dispatch = useDispatch()

    const [page, setPage] = useState(1);
    const [parent_barcode, setParent_barcode] = useState("");
    const [child_barcode, setChild_barcode] = useState("");
    const [description, setDescription] = useState("");
    const { loading, mappings, totalPages, totalMappings } = useSelector(state => state.myMappings)
    const { message } = useSelector(state => state.mapping)

    useEffect(() => {
        const query = {}
        if (parent_barcode) query.parent_barcode = toSearchBarcode(parent_barcode)
        if (child_barcode) query.child_barcode = toSearchBarcode(child_barcode)
        if (description.trim()) query.description = description.trim()

        const timer = setTimeout(() => {
            dispatch(allMappingsAction(page, query));
        }, 400);

        return () => clearTimeout(timer);
    }, [dispatch, page, parent_barcode, child_barcode, description, message]);

    return (
        <Fragment>
            {loading && <Loader />}
            <section className="pl-[1.5vmax] pr-[1.5vmax_2vmax] mt-[1vmax] mb-[4vmax]">
                <div className="p-[2vmax] bg-white shadow-1 rounded-2xl">
                    <div className="flex justify-between items-center py-[1vmax]">
                        <h2 className="text-[1.5vmax] font-2 font-bold">Master Price Book List</h2>
                        {totalMappings > 0 && (
                            <span className="text-[0.9vmax] text-slate-500">
                                {totalMappings.toLocaleString()} total entries
                            </span>
                        )}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-[1.5vmax]">

                        <div className="flex w-full customBG-6 mt-[0.5vmax] rounded-xl">
                            <input
                                type="text"
                                value={parent_barcode}
                                onChange={(e) => { setParent_barcode(e.target.value); setPage(1); }}
                                onBlur={() => {
                                    const normalized = normalizeUpc(parent_barcode);
                                    if (normalized) setParent_barcode(normalized);
                                }}
                                className=' bg-white rounded-l-xl px-[0.5vmax]  py-[0.7vmax]    outline-none text-[1.8vmax] lg:text-[0.9vmax]  text-gray-600 font-[500]  border-l-[0.1vmax] border-gray-300 w-[85%]'
                                placeholder='Search by Case Barcode'
                            />
                            <div className="text-right bg-white w-[15%] rounded-r-xl flex items-center justify-end pr-[1vmax] text-[var(--color-4)] text-[2vmax] lg:text-[1.1vmax]">
                                <i className="fa-solid fa-magnifying-glass "></i>
                            </div>
                        </div>

                        <div className="flex w-full customBG-6 mt-[0.5vmax] rounded-xl">
                            <input
                                type="text"
                                value={child_barcode}
                                onChange={(e) => { setChild_barcode(e.target.value); setPage(1); }}
                                onBlur={() => {
                                    const normalized = normalizeUpc(child_barcode);
                                    if (normalized) setChild_barcode(normalized);
                                }}
                                className=' bg-white rounded-l-xl px-[0.5vmax]  py-[0.7vmax]    outline-none text-[1.8vmax] lg:text-[0.9vmax]  text-gray-600 font-[500]  border-l-[0.1vmax] border-gray-300 w-[85%]'
                                placeholder='Search by Item Barcode'
                            />
                            <div className="text-right bg-white w-[15%] rounded-r-xl flex items-center justify-end pr-[1vmax] text-[var(--color-4)] text-[2vmax] lg:text-[1.1vmax]">
                                <i className="fa-solid fa-magnifying-glass "></i>
                            </div>
                        </div>

                        <div className="flex w-full customBG-6 mt-[0.5vmax] rounded-xl">
                            <input
                                type="text"
                                value={description}
                                onChange={(e) => { setDescription(e.target.value); setPage(1); }}
                                className=' bg-white rounded-l-xl px-[0.5vmax]  py-[0.7vmax]    outline-none text-[1.8vmax] lg:text-[0.9vmax]  text-gray-600 font-[500]  border-l-[0.1vmax] border-gray-300 w-[85%]'
                                placeholder='Search by Description'
                            />
                            <div className="text-right bg-white w-[15%] rounded-r-xl flex items-center justify-end pr-[1vmax] text-[var(--color-4)] text-[2vmax] lg:text-[1.1vmax]">
                                <i className="fa-solid fa-magnifying-glass "></i>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-[0.4fr_1fr_0.6fr_1fr_1.5fr_0.6fr_0.8fr] mt-[2vmax] bg-gray-100 py-[0.5vmax] rounded-2xl">
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax] th-center">No.</div>
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax] th-text">Case Barcode</div>
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax] th-center">Unit/Case</div>
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax] th-text">Item Barcode</div>
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax] th-text">Description</div>
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax] th-center">Taxable</div>
                        <div className="text-[1vmax] font-2 font-bold px-[1vmax] th-center">Action</div>
                    </div>
                    {mappings?.length > 0 ? (
                        mappings.map((mapping, index) => (
                            <div key={mapping.id} className="grid grid-cols-[0.4fr_1fr_0.6fr_1fr_1.5fr_0.6fr_0.8fr] py-[0.8vmax] border-b border-gray-100 last:border-0">
                                <div className="text-[0.9vmax] font-2 px-[1vmax] td-center">
                                    {totalMappings - (index + ((page - 1) * 20))}
                                </div>
                                <div className="text-[0.9vmax] font-2 px-[1vmax] td-num">{mapping.parent_barcode}</div>
                                <div className="text-[0.9vmax] font-2 px-[1vmax] td-center">{mapping.unit_case}</div>
                                <div className="text-[0.9vmax] font-2 px-[1vmax] td-num">{mapping.child_barcode}</div>
                                <div className="text-[0.9vmax] font-2 px-[1vmax] td-text text-slate-500">{mapping.description || "—"}</div>
                                <div className="text-[0.9vmax] font-2 px-[1vmax] td-center">
                                    {mapping.taxable ? <i className="fa-solid fa-check text-green-500" /> : "—"}
                                </div>
                                <div className="text-[0.9vmax] font-2 px-[1vmax] flex items-center justify-center gap-[1vmax]">
                                    <MappingButtons mapping={mapping} validateBarcode={validateBarcode} />
                                </div>
                            </div>
                        ))
                    ) : (
                        !loading && (
                            <div className="text-[1.5vmax] font-2 text-center py-[1.5vmax]">No Entries</div>
                        )
                    )}

                    <Pagination page={page} totalPages={totalPages} setPage={setPage} />
                </div>
            </section>
        </Fragment>
    )
}

export default MappingList
